<template>
    <div>
        <toolbar :title="'MwSt.-Rechner'" :isMain="true"></toolbar>

          <v-divider></v-divider>

            <v-responsive>
                <v-card-text >

                    <v-layout row wrap>

                        <v-flex xs12>
                            <NumberField
                                  :label="'Netto-Betrag'"
                                  :fieldtype="'netto'"
                                  :tabindex="10"
                                  v-on:showSnackbar="_showSnackbar($event)"
                                  v-on:changedField="_changedField($event)"></NumberField>
                        </v-flex>

                        <v-flex xs12>
                            <NumberField
                                  :label="'MwSt.-Betrag'"
                                  :fieldtype="'mwst'"
                                  :tabindex="20"
                                  v-on:showSnackbar="_showSnackbar($event)"
                                  v-on:changedField="_changedField($event)"></NumberField>
                        </v-flex>

                        <v-flex xs12>
                            <NumberField
                                  :label="'Brutto-Betrag'"
                                  :fieldtype="'brutto'"
                                  :tabindex="30"
                                  v-on:showSnackbar="_showSnackbar($event)"
                                  v-on:changedField="_changedField($event)"></NumberField>
                        </v-flex>

                        <!-- SELECT BOX FÜR AKTUELLEN STEUERSATZ -->
                        <SelectSteuersatz
                              :tabindex="40"
                              v-on:changedMwst="_changedField($event)"
                              v-on:openDialog="dialogSteuersaetze=true"></SelectSteuersatz>

                    </v-layout>

                </v-card-text>

            </v-responsive>
    </div>
</template>

<script>
    import NumberField from "../elements/NumberField";
    import SelectSteuersatz from "../elements/SelectSteuersatz";

    export default {
        name: 'mainPage',
        components: {
             NumberField,
            SelectSteuersatz
        },
        data: () => ({
            tempValues: {
                "netto": 0,
                "brutto": 0,
                "mwst": 0
            }
        }),
        computed: {
            lastCalcAction: {
                get() {
                    return this.$store.getters["lastCalcAction"];
                },
                set: function(val) {
                    this.$store.dispatch("lastCalcAction", val);
                }
            },
            brutto: {
                get() {
                    return this.$store.getters["brutto"];
                },
                set: function(val) {
                    this.$store.dispatch("brutto", val);
                }
            },
            netto: {
                get() {
                    return this.$store.getters["netto"];
                },
                set: function(val) {
                    this.$store.dispatch("netto", val);
                }
            },
            mwst: {
                get() {
                    return this.$store.getters["mwst"];
                },
                set: function(val) {
                    this.$store.dispatch("mwst", val);
                }
            },
            currSteuersatz: {
                get() {
                    let ret = this.$store.getters["steuersatz"];
                    return ret.val;
                }
            },

        },
        methods: {

            _changedField(fieldtype){

                //console.log(fieldtype);

                if ( fieldtype !== null && typeof fieldtype !== "undefined" && typeof fieldtype.typ !== "undefined" ) {
                    fieldtype = fieldtype.typ;
                    this.lastCalcAction = fieldtype;
                }
                else {
                    fieldtype = this.lastCalcAction;
                }

                let bruttowert = 0;
                let nettowert = 0;

                //console.table({netto: this.netto, brutto: this.brutto, mwst: this.mwst, currsteuer: this.currSteuersatz});

                try {
                    if (fieldtype === 'netto') {
                        bruttowert = parseFloat(this.netto) + (parseFloat(this.netto) / 100) * parseFloat(this.currSteuersatz);
                        if (bruttowert > 0) {
                            this.brutto = bruttowert.toFixed(2)
                        }
                        else {
                            this.brutto = '';
                        }
                    }
                    else if (fieldtype === 'brutto') {
                        let wert = this.currSteuersatz;
                        if (wert.length === 1) {
                            wert = '0' + wert;
                        }
                        nettowert = this.brutto / (parseFloat('1.' + wert));
                        if (nettowert > 0) {
                            this.netto = nettowert.toFixed(2)
                        }
                        else {
                            this.netto = '';
                        }
                    }
                    else if (fieldtype === 'mwst') {
                        let temp = (parseFloat(this.mwst) / parseFloat(this.currSteuersatz)) * 100;
                        if (temp > 0) {
                            this.netto = temp.toFixed(2);
                            let br = temp + parseFloat(this.mwst);
                            this.brutto= br.toFixed(2)
                        }
                    }

                    if (fieldtype === 'netto' || fieldtype === 'brutto') {
                        let anteil = this.brutto - this.netto;
                        if (anteil > 0 || nettowert > 0 || bruttowert > 0) {
                            this.mwst = anteil.toFixed(2);
                        }
                        else {
                            this.mwst = '';
                        }
                    }
                }
                catch (e) {
                    //console.log(e);
                }

                //console.table({netto: this.netto, brutto: this.brutto, mwst: this.mwst});

                this.tempValues[fieldtype.typ] = fieldtype.value;
            },
        },
        mounted: function() {
            this._changedField();
        }
    }
</script>

<style scoped>

</style>